import React, { useEffect, useState } from "react";
import styled from "styled-components";

import Cookies from "js-cookie";
import Modal from "react-modal";
import { Container, P } from "@util/standard";
import { Button, IconButton, Image } from "@global";
import { usePopupQuery } from "@query";
import { useCheckScreenWidth } from "@util/hooks";

const CloseContainer = styled(Container)`
  position: absolute;
  top: 20px;
  right: 15px;
  z-index: 2;
`;

const WelcomeModal = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const popupQuery = usePopupQuery(process.env.GATSBY_IBAN);
  const { isTabletWidth, isMobileWidth } = useCheckScreenWidth();

  if (popupQuery == null) return null;

  const { title, description, link, image } = popupQuery;

  useEffect(() => {
    //first mount
    const checkCookie = Cookies.get("firstDisplay");
    if (!checkCookie || checkCookie == undefined) {
      //Display modal
      setModalVisible(true);
      Cookies.set("firstDisplay", "true");
    }
  }, []);

  const closeModal = () => {
    setModalVisible(false);
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
    overlay: {
      zIndex: 30,
    },
  };

  const imageStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: isTabletWidth || isMobileWidth ? "calc(100% - 40px)" : "60%",
      padding: "0",
    },
    overlay: {
      zIndex: 30,
    },
  };

  const handleClick = () => {
    closeModal();
  };

  if (!title && !description && !link?.url == null) return null;

  return (
    <Modal
      style={image ? imageStyles : customStyles}
      isOpen={modalVisible}
      onRequestClose={closeModal}
    >
      <CloseContainer>
        <IconButton icon="close" onClick={closeModal} />
      </CloseContainer>
      <Container alignItems="center" flexWrap="wrap">
        {image && (
          <Container width="50%" tabletWidth="100%">
            <Image
              imageData={image.asset?.gatsbyImageData}
              width="100%"
              height={isTabletWidth || isMobileWidth ? "20vh" : "70vh"}
              objectFit="cover"
            />
          </Container>
        )}
        <Container
          width={image ? "50%" : "100%"}
          tabletWidth="100%"
          flexDirection="column"
          alignItems="center"
          padding="20px"
        >
          <P textAlign="center" fontSize={24} margin="30px auto 0px auto">
            {title}
          </P>
          <P textAlign="center" margin="10px auto 30px auto">
            {description}
          </P>
          {link?.url != null && (
            <Button
              theme="transparent"
              linkTo={link?.internallink === true ? link.url : undefined}
              linkToNewWindow={
                link?.internallink === false ? link.url : undefined
              }
              text={link?.linktext ?? "Submit"}
              onClick={handleClick}
            />
          )}
        </Container>
      </Container>
    </Modal>
  );
};

export default WelcomeModal;
